import { createApp } from "vue"; // Vue 앱 인스턴스 생성
import App from "./App.vue";
import router from "@/router"; // 라우터 등록
import vuetify from "@/common/plugins/vuetify"; // Vuetify 플러그인
import i18n from "@/i18n"; // 다국어(i18n) 설정
import global from "@/app/plugins/global"; // 전역 헬퍼/프로퍼티
import { createPinia } from "pinia"; // Pinia
import piniaPlugin from "pinia-plugin-persistedstate"; // Pinia 상태 영속 플러그인
import { setAxios } from "@/api/Axios"; // Axios 설정
import EasyDataTable from "@/common/plugins/easyTable"; // table 컴포넌트
import purifyPlugin from "@/common/plugins/dompurify"; // DOMPurify 플러그인 (XSS)
import { useDevice } from "@/app/util/device";
import { useDynamicStyle } from "@/common/plugins/style";

// 베이스 컴포넌트 객체
import { Base } from "@/common/base-components/BaseFactory.ts";

// router navigation
import { navigationGuard } from "@/router/NavigationGuard";

// 전역 스타일(Scss)
// import "@/assets/common/scss/style.scss"; // 전역 스타일
const { applyStyle } = useDynamicStyle();
applyStyle("common");

// Pinia 인스턴스 생성
const pinia = createPinia(); // Pinia 스토어 생성
pinia.use(piniaPlugin); // 상태 영속화 플러그인 적용

// 앱 인스턴스 생성 및 전역 컴포넌트/플러그인 등록
const app = createApp(App); // 앱 생성

// 전역 컴포넌트 등록
app.component("BaseInput", Base.Input);
app.component("BaseButton", Base.Button);
app.component("VEasyTable", EasyDataTable);

// 전역 플러그인 사용
app.use(purifyPlugin); // DOM 정화 플러그인 등록
app.use(pinia); // Pinia 등록
app.use(setAxios); // Axios 인터셉터/기본설정 등록
app.use(i18n); // i18n 등록

// favicon 동적 설정 (i18n 로드 후 실행)
const setFavicon = (): void => {
  // pbl 모드에서는 기본 파비콘 유지
  if (import.meta.env.MODE === "pbl") {
    return;
  }

  const faviconPath = i18n.global.t("siteConfig.favicon");

  // 키값 자체가 반환되지 않았는지 확인
  if (faviconPath && faviconPath !== "siteConfig.favicon") {
    let faviconLink = document.querySelector('link[rel~="icon"]') as HTMLLinkElement;

    if (!faviconLink) {
      faviconLink = document.createElement("link");
      faviconLink.rel = "icon";
      document.head.appendChild(faviconLink);
    }

    faviconLink.href = `${faviconPath}?v=${new Date().getTime()}`;
  } else {
    console.warn("Favicon 경로를 찾을 수 없음:", faviconPath);
  }
};

setFavicon();

app.use(global); // 전역 헬퍼/프로퍼티 등록
app.use(router); // 라우터 등록 (라우트 사용 가능)
app.use(vuetify); // Vuetify UI 프레임워크 적용

// 네비게이션 가드 적용
navigationGuard(router);
// device 해상도 초기화 및 이벤트 리스너 등록
useDevice();

app.mount("#app"); // DOM에 앱 마운트
